import { render, staticRenderFns } from "./ButtonClear.vue?vue&type=template&id=af6c7a70&scoped=true"
import script from "./ButtonClear.vue?vue&type=script&lang=js"
export * from "./ButtonClear.vue?vue&type=script&lang=js"
import style0 from "./ButtonClear.vue?vue&type=style&index=0&id=af6c7a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6c7a70",
  null
  
)

export default component.exports